import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { uiStore } from 'shared/store/uiStore'
import { openIntercom } from 'entities/Intercom'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { SettingsRoutes } from 'pages/settings/route/type'
import { HipaaAddOnModalContent } from 'pages/settings/ui/HipaaAddOnModal/HipaaAddOnModalContent'
import { HipaaAddOnModalActions } from 'pages/settings/ui/HipaaAddOnModal/HipaaAddOnModalActions'

export const HIPAA_ADD_ON_MODAL_ID = 'hipaa-add-on-modal'

type IOpenHipaaAddOnModalParams = {
  entities: IEntitiesStore
}

export const openHipaaAddOnModal = ({ entities }: IOpenHipaaAddOnModalParams) => {
  const isActive = entities.organizationStore.isHipaaCompliant

  const closeModal = () => modalStore.closeModal(HIPAA_ADD_ON_MODAL_ID)

  const handlePrimary = () => {
    closeModal()

    if (isActive) {
      uiStore.changeRoute({
        path: `/${SettingsRoutes.root}/${SettingsRoutes.general}`,
        query: 'category=security',
      })
      return
    }

    entities.organizationStore.handleTrackOrganizationActivity({
      event: 'hipaa.compliance.requested',
    })
    openIntercom()
  }

  modalStore.addModal({
    id: HIPAA_ADD_ON_MODAL_ID,
    type: ModalTypeList.DEFAULT,
    width: 540,
    title: 'Details',
    showCloseButton: false,
    ModalContent: () => <HipaaAddOnModalContent />,
    ModalActions: () => (
      <HipaaAddOnModalActions isActive={isActive} onCancel={closeModal} onPrimary={handlePrimary} />
    ),
  })
}
